module.exports = __webpack_public_path__ + "assets/gun-91d8a27eff5bccacd30e5aa811b73301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/gun.jpg
// module id = 514
// module chunks = 1